<template>
  <transition name="threaded-comments-form-slide-up">
    <threaded-comments-form
      v-if="parent && showCommentsForm"
      :obituary-id="obituaryId"
    />

    <threaded-comments-delete v-else-if="parent && showDeleteContent" />
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import { useIsMobile } from 'Main/composables/useIsMobile';
import ThreadedCommentsDelete from './Delete.vue';
import ThreadedCommentsForm from './Form.vue';

export default {
  name: 'ThreadedCommentsMobileModal',

  components: {
    ThreadedCommentsDelete,
    ThreadedCommentsForm,
  },

  setup() {
    const { isMobile, isTablet } = useIsMobile();
    return { isMobile, isTablet };
  },

  props: {
    obituaryId: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState('threadedComments', {
      context: 'modalContext',
      parent: 'parent',
    }),

    showCommentsForm() {
      return this.context === 'create' || this.context === 'edit';
    },

    showDeleteContent() {
      return this.context === 'delete';
    },
  },
};
</script>
